import type { CrawlItemKind, CrawlItemSubject } from '@zyx/shared';
import { Link } from 'react-router-dom';
import { describeSubject, ITEM_KIND_LABELS } from '@/lib/crawl-labels';
import { urls } from '@/lib/urls';

/**
 * One crawl item in a row: its kind, the movie it belongs to (a link), what it is, and
 * the raw target underneath. A listing page has nothing more to say than its URL.
 * Inside a button the code is plain text, since a link may not sit inside one.
 */
export function ItemLabel(props: { readonly kind: CrawlItemKind; readonly target: string; readonly subject?: CrawlItemSubject; readonly hideKind?: boolean; readonly linkCode?: boolean }) {
  const description = describeSubject(props.kind, props.subject);
  const code = props.subject?.code;
  return (
    <span className="block min-w-0">
      <span className="flex min-w-0 flex-wrap items-baseline gap-x-2">
        {props.hideKind === true ? null : <span className="text-muted-foreground">{ITEM_KIND_LABELS[props.kind]}</span>}
        {code === undefined ? null : props.linkCode === false ? (
          <span className="font-medium">{code}</span>
        ) : (
          <Link to={urls.movie(code)} className="font-medium text-primary hover:underline" onClick={(event) => event.stopPropagation()}>
            {code}
          </Link>
        )}
        {description === undefined ? null : <span>{description}</span>}
      </span>
      <span className="block truncate font-mono text-[11px] text-muted-foreground" title={props.target}>
        {props.target}
      </span>
    </span>
  );
}
